import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {CreateResult, ListResult, SingleResult, UpdateResult} from './lib-rest';

export class ProductApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async create(body: ProductController$CreateProductJson): Promise<CreateResult>  {
const url =  new URL('/products', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(body))).data
  }

 public  async deactivate(productId: string): Promise<UpdateResult>  {
const url =  new URL('/products/' + productId + '/deactivate', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

 public  async get(productId: string): Promise<SingleResult<ProductController$ProductJson> >  {
const url =  new URL('/products/' + productId + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async getByType(productType: string): Promise<SingleResult<ProductController$ProductJson> >  {
const url =  new URL('/products/type/' + productType + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async linkToCreemProduct(productId: string, body: ProductController$LinkCreemProductJson): Promise<UpdateResult>  {
const url =  new URL('/products/' + productId + '/creem-link', this.config.host);

return (await HttpService.getAxiosClient().put(url.toString(),JSON.stringify(body))).data
  }

 public  async listAll(): Promise<ListResult<ProductController$ProductJson> >  {
const url =  new URL('/products', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async update(productId: string, body: ProductController$UpdateProductJson): Promise<UpdateResult>  {
const url =  new URL('/products/' + productId + '', this.config.host);

return (await HttpService.getAxiosClient().put(url.toString(),JSON.stringify(body))).data
  }

}

export interface ProductController$CreateProductJson {
  currency: string;
  description: string;
  includesTax: boolean;
  name: string;
  price: number | null;
  productType: string;
}

export interface ProductController$LinkCreemProductJson {
  creemProductId: string;
}

export interface ProductController$ProductJson {
readonly   active: boolean;
  currency: string;
  description: string;
  includesTax: boolean;
  isActive: boolean;
  linkedProduct: string;
  name: string;
  price: number | null;
  productId: string;
  productType: string;
}

export interface ProductController$UpdateProductJson {
readonly   active: boolean;
  currency: string;
  description: string;
  includesTax: boolean;
  isActive: boolean;
  name: string;
  price: number | null;
}

